/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * CyrenCare API
 * CyrenCare NestJS REST API for healthcare survey platform
 * OpenAPI spec version: 2.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ApiResponseDto,
  BulkUpsertTranslationDto,
  CreateTranslationDto,
  Object,
  SearchTranslationDto,
  SearchTranslationResponseDto,
  TransForQuestionDto,
  TransForTreesDto,
  TranslateDto,
  TranslateEntryBatchDto,
  TranslateEntryBatchResponseDto,
  TranslateEntryDto,
  TranslateSurveyDto,
  TranslateSurveyResponseDto,
  TranslateUserNotesDto,
  TranslationControllerTranslateUserNotes200,
  TranslationResponseDto,
  TranslationReviewDeleteDto,
  TranslationReviewDeleteResponseDto,
  TranslationReviewExportDto,
  TranslationReviewExportResponseDto,
  TranslationReviewImportDto,
  TranslationReviewImportResponseDto,
  TranslationReviewScanDto,
  TranslationReviewScanResponseDto,
  UpdateTranslationDto,
  UpsertTransListDto,
  UpsertTransListResponseDto,
  UpsertTranslationDto
} from '.././types'
import { customInstance } from '../../custom-instance';
import type { ErrorType } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Translate text to a single target language
 */
export const translationControllerTranslate = (
    translateDto: TranslateDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/translation/translate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translateDto
    },
      options);
    }
  


export const getTranslationControllerTranslateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslate>>, TError,{data: TranslateDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslate>>, TError,{data: TranslateDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerTranslate>>, {data: TranslateDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerTranslate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerTranslateMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerTranslate>>>
    export type TranslationControllerTranslateMutationBody = TranslateDto
    export type TranslationControllerTranslateMutationError = ErrorType<void>

    /**
 * @summary Translate text to a single target language
 */
export const useTranslationControllerTranslate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslate>>, TError,{data: TranslateDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerTranslate>>,
        TError,
        {data: TranslateDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerTranslateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Translate text to multiple target languages (uses supported languages from config)
 */
export const translationControllerTranslateMultiple = (
    translateDto: TranslateDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/translation/translate-multiple`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translateDto
    },
      options);
    }
  


export const getTranslationControllerTranslateMultipleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateMultiple>>, TError,{data: TranslateDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateMultiple>>, TError,{data: TranslateDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerTranslateMultiple>>, {data: TranslateDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerTranslateMultiple(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerTranslateMultipleMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerTranslateMultiple>>>
    export type TranslationControllerTranslateMultipleMutationBody = TranslateDto
    export type TranslationControllerTranslateMultipleMutationError = ErrorType<void>

    /**
 * @summary Translate text to multiple target languages (uses supported languages from config)
 */
export const useTranslationControllerTranslateMultiple = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateMultiple>>, TError,{data: TranslateDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerTranslateMultiple>>,
        TError,
        {data: TranslateDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerTranslateMultipleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Upsert translation entry using msgid as translation base key
 */
export const translationControllerTranslateEntry = (
    translateEntryDto: TranslateEntryDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TranslationResponseDto>(
      {url: `/translation/translate-entry`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translateEntryDto
    },
      options);
    }
  


export const getTranslationControllerTranslateEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateEntry>>, TError,{data: TranslateEntryDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateEntry>>, TError,{data: TranslateEntryDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerTranslateEntry>>, {data: TranslateEntryDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerTranslateEntry(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerTranslateEntryMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerTranslateEntry>>>
    export type TranslationControllerTranslateEntryMutationBody = TranslateEntryDto
    export type TranslationControllerTranslateEntryMutationError = ErrorType<unknown>

    /**
 * @summary Upsert translation entry using msgid as translation base key
 */
export const useTranslationControllerTranslateEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateEntry>>, TError,{data: TranslateEntryDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerTranslateEntry>>,
        TError,
        {data: TranslateEntryDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerTranslateEntryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Batch upsert translation entries using msgid as base key
 */
export const translationControllerTranslateEntries = (
    translateEntryBatchDto: TranslateEntryBatchDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TranslateEntryBatchResponseDto>(
      {url: `/translation/translate-entries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translateEntryBatchDto
    },
      options);
    }
  


export const getTranslationControllerTranslateEntriesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateEntries>>, TError,{data: TranslateEntryBatchDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateEntries>>, TError,{data: TranslateEntryBatchDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerTranslateEntries>>, {data: TranslateEntryBatchDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerTranslateEntries(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerTranslateEntriesMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerTranslateEntries>>>
    export type TranslationControllerTranslateEntriesMutationBody = TranslateEntryBatchDto
    export type TranslationControllerTranslateEntriesMutationError = ErrorType<unknown>

    /**
 * @summary Batch upsert translation entries using msgid as base key
 */
export const useTranslationControllerTranslateEntries = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateEntries>>, TError,{data: TranslateEntryBatchDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerTranslateEntries>>,
        TError,
        {data: TranslateEntryBatchDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerTranslateEntriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Translate user notes for reports (cache-first, Google fallback)
 */
export const translationControllerTranslateUserNotes = (
    translateUserNotesDto: TranslateUserNotesDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TranslationControllerTranslateUserNotes200>(
      {url: `/translation/translate-user-notes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translateUserNotesDto
    },
      options);
    }
  


export const getTranslationControllerTranslateUserNotesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateUserNotes>>, TError,{data: TranslateUserNotesDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateUserNotes>>, TError,{data: TranslateUserNotesDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerTranslateUserNotes>>, {data: TranslateUserNotesDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerTranslateUserNotes(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerTranslateUserNotesMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerTranslateUserNotes>>>
    export type TranslationControllerTranslateUserNotesMutationBody = TranslateUserNotesDto
    export type TranslationControllerTranslateUserNotesMutationError = ErrorType<unknown>

    /**
 * @summary Translate user notes for reports (cache-first, Google fallback)
 */
export const useTranslationControllerTranslateUserNotes = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateUserNotes>>, TError,{data: TranslateUserNotesDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerTranslateUserNotes>>,
        TError,
        {data: TranslateUserNotesDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerTranslateUserNotesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get supported translation languages for organization
 */
export const translationControllerGetSupportedLanguages = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/translation/supported-languages`, method: 'GET', signal
    },
      options);
    }
  

export const getTranslationControllerGetSupportedLanguagesQueryKey = () => {
    return [`/translation/supported-languages`] as const;
    }

    
export const getTranslationControllerGetSupportedLanguagesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTranslationControllerGetSupportedLanguagesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>> = ({ signal }) => translationControllerGetSupportedLanguages(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>, TError, TData> & { queryKey: QueryKey }
}

export type TranslationControllerGetSupportedLanguagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>>
export type TranslationControllerGetSupportedLanguagesInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get supported translation languages for organization
 */
export const useTranslationControllerGetSupportedLanguagesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTranslationControllerGetSupportedLanguagesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTranslationControllerGetSupportedLanguagesQueryOptions = <TData = Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTranslationControllerGetSupportedLanguagesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>> = ({ signal }) => translationControllerGetSupportedLanguages(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>, TError, TData> & { queryKey: QueryKey }
}

export type TranslationControllerGetSupportedLanguagesQueryResult = NonNullable<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>>
export type TranslationControllerGetSupportedLanguagesQueryError = ErrorType<unknown>

/**
 * @summary Get supported translation languages for organization
 */
export const useTranslationControllerGetSupportedLanguages = <TData = Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof translationControllerGetSupportedLanguages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTranslationControllerGetSupportedLanguagesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update supported translation languages for organization
 */
export const translationControllerUpdateSupportedLanguages = (
    translationControllerUpdateSupportedLanguagesBody: Object,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/translation/supported-languages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translationControllerUpdateSupportedLanguagesBody
    },
      options);
    }
  


export const getTranslationControllerUpdateSupportedLanguagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpdateSupportedLanguages>>, TError,{data: Object}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpdateSupportedLanguages>>, TError,{data: Object}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerUpdateSupportedLanguages>>, {data: Object}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerUpdateSupportedLanguages(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerUpdateSupportedLanguagesMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerUpdateSupportedLanguages>>>
    export type TranslationControllerUpdateSupportedLanguagesMutationBody = Object
    export type TranslationControllerUpdateSupportedLanguagesMutationError = ErrorType<unknown>

    /**
 * @summary Update supported translation languages for organization
 */
export const useTranslationControllerUpdateSupportedLanguages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpdateSupportedLanguages>>, TError,{data: Object}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerUpdateSupportedLanguages>>,
        TError,
        {data: Object},
        TContext
      > => {

      const mutationOptions = getTranslationControllerUpdateSupportedLanguagesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Survey의 특정 Tree들에 필요한 모든 번역 데이터를 가져옵니다. (Step name, description, questions, options 등)
 * @summary Get translations for trees
 */
export const translationControllerTransForTrees = (
    transForTreesDto: TransForTreesDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/translation/trans-for-trees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transForTreesDto
    },
      options);
    }
  


export const getTranslationControllerTransForTreesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTransForTrees>>, TError,{data: TransForTreesDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerTransForTrees>>, TError,{data: TransForTreesDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerTransForTrees>>, {data: TransForTreesDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerTransForTrees(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerTransForTreesMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerTransForTrees>>>
    export type TranslationControllerTransForTreesMutationBody = TransForTreesDto
    export type TranslationControllerTransForTreesMutationError = ErrorType<void>

    /**
 * @summary Get translations for trees
 */
export const useTranslationControllerTransForTrees = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTransForTrees>>, TError,{data: TransForTreesDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerTransForTrees>>,
        TError,
        {data: TransForTreesDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerTransForTreesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * V1의 PaQuestions API와 유사한 역할. body_select_whole 등에서 subpart 클릭 시 해당 질문의 번역(questionKey + answerKeys)을 가져옵니다.
 * @summary Get translations for a specific question
 */
export const translationControllerTransForQuestion = (
    transForQuestionDto: TransForQuestionDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/translation/trans-for-question`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transForQuestionDto
    },
      options);
    }
  


export const getTranslationControllerTransForQuestionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTransForQuestion>>, TError,{data: TransForQuestionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerTransForQuestion>>, TError,{data: TransForQuestionDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerTransForQuestion>>, {data: TransForQuestionDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerTransForQuestion(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerTransForQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerTransForQuestion>>>
    export type TranslationControllerTransForQuestionMutationBody = TransForQuestionDto
    export type TranslationControllerTransForQuestionMutationError = ErrorType<void>

    /**
 * @summary Get translations for a specific question
 */
export const useTranslationControllerTransForQuestion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTransForQuestion>>, TError,{data: TransForQuestionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerTransForQuestion>>,
        TError,
        {data: TransForQuestionDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerTransForQuestionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * V1의 createTranslation mutation과 동일한 기능. 새로운 번역 데이터를 생성합니다.
 * @summary Create a translation
 */
export const translationControllerCreate = (
    createTranslationDto: CreateTranslationDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/translation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTranslationDto
    },
      options);
    }
  


export const getTranslationControllerCreateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerCreate>>, TError,{data: CreateTranslationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerCreate>>, TError,{data: CreateTranslationDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerCreate>>, {data: CreateTranslationDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerCreate>>>
    export type TranslationControllerCreateMutationBody = CreateTranslationDto
    export type TranslationControllerCreateMutationError = ErrorType<void>

    /**
 * @summary Create a translation
 */
export const useTranslationControllerCreate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerCreate>>, TError,{data: CreateTranslationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerCreate>>,
        TError,
        {data: CreateTranslationDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 번역 ID로 단일 번역 데이터를 조회합니다.
 * @summary Get a translation by ID
 */
export const translationControllerFindOne = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/translation/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getTranslationControllerFindOneQueryKey = (id: number,) => {
    return [`/translation/${id}`] as const;
    }

    
export const getTranslationControllerFindOneInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof translationControllerFindOne>>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof translationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTranslationControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof translationControllerFindOne>>> = ({ signal }) => translationControllerFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof translationControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type TranslationControllerFindOneInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof translationControllerFindOne>>>
export type TranslationControllerFindOneInfiniteQueryError = ErrorType<void>

/**
 * @summary Get a translation by ID
 */
export const useTranslationControllerFindOneInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof translationControllerFindOne>>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof translationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTranslationControllerFindOneInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTranslationControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof translationControllerFindOne>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof translationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTranslationControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof translationControllerFindOne>>> = ({ signal }) => translationControllerFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof translationControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type TranslationControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof translationControllerFindOne>>>
export type TranslationControllerFindOneQueryError = ErrorType<void>

/**
 * @summary Get a translation by ID
 */
export const useTranslationControllerFindOne = <TData = Awaited<ReturnType<typeof translationControllerFindOne>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof translationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTranslationControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * V1의 updateTranslation mutation과 동일한 기능. 기존 번역 데이터를 수정합니다.
 * @summary Update a translation
 */
export const translationControllerUpdate = (
    id: number,
    updateTranslationDto: UpdateTranslationDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/translation/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTranslationDto
    },
      options);
    }
  


export const getTranslationControllerUpdateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpdate>>, TError,{id: number;data: UpdateTranslationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpdate>>, TError,{id: number;data: UpdateTranslationDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerUpdate>>, {id: number;data: UpdateTranslationDto}> = (props) => {
          const {id,data} = props ?? {};

          return  translationControllerUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerUpdate>>>
    export type TranslationControllerUpdateMutationBody = UpdateTranslationDto
    export type TranslationControllerUpdateMutationError = ErrorType<void>

    /**
 * @summary Update a translation
 */
export const useTranslationControllerUpdate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpdate>>, TError,{id: number;data: UpdateTranslationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerUpdate>>,
        TError,
        {id: number;data: UpdateTranslationDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * V1의 deleteTranslation mutation과 동일한 기능. 번역 데이터를 삭제합니다.
 * @summary Delete a translation
 */
export const translationControllerDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/translation/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getTranslationControllerDeleteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerDelete>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerDelete>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerDelete>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  translationControllerDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerDelete>>>
    
    export type TranslationControllerDeleteMutationError = ErrorType<void>

    /**
 * @summary Delete a translation
 */
export const useTranslationControllerDelete = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerDelete>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerDelete>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getTranslationControllerDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * key + locale + surveyId + type으로 기존 데이터를 찾아 있으면 update, 없으면 create합니다.
 * @summary Upsert a single translation
 */
export const translationControllerUpsert = (
    upsertTranslationDto: UpsertTranslationDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/translation/upsert`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertTranslationDto
    },
      options);
    }
  


export const getTranslationControllerUpsertMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpsert>>, TError,{data: UpsertTranslationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpsert>>, TError,{data: UpsertTranslationDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerUpsert>>, {data: UpsertTranslationDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerUpsert(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerUpsert>>>
    export type TranslationControllerUpsertMutationBody = UpsertTranslationDto
    export type TranslationControllerUpsertMutationError = ErrorType<unknown>

    /**
 * @summary Upsert a single translation
 */
export const useTranslationControllerUpsert = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpsert>>, TError,{data: UpsertTranslationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerUpsert>>,
        TError,
        {data: UpsertTranslationDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * V1의 useMultiTransEdit.saveLocales()와 동일한 기능. 여러 번역을 한번에 저장합니다. 각 번역은 key + locale + surveyId + type으로 기존 데이터를 찾아 있으면 update, 없으면 create합니다.
 * @summary Bulk upsert translations
 */
export const translationControllerBulkUpsert = (
    bulkUpsertTranslationDto: BulkUpsertTranslationDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/translation/bulk-upsert`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpsertTranslationDto
    },
      options);
    }
  


export const getTranslationControllerBulkUpsertMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerBulkUpsert>>, TError,{data: BulkUpsertTranslationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerBulkUpsert>>, TError,{data: BulkUpsertTranslationDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerBulkUpsert>>, {data: BulkUpsertTranslationDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerBulkUpsert(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerBulkUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerBulkUpsert>>>
    export type TranslationControllerBulkUpsertMutationBody = BulkUpsertTranslationDto
    export type TranslationControllerBulkUpsertMutationError = ErrorType<unknown>

    /**
 * @summary Bulk upsert translations
 */
export const useTranslationControllerBulkUpsert = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerBulkUpsert>>, TError,{data: BulkUpsertTranslationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerBulkUpsert>>,
        TError,
        {data: BulkUpsertTranslationDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerBulkUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 키/값 배열을 기반으로 영문 번역을 저장하고, 옵션에 따라 자동 번역을 수행합니다.
 * @summary Upsert translation list (V1 upsertTransList)
 */
export const translationControllerUpsertTransList = (
    upsertTransListDto: UpsertTransListDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UpsertTransListResponseDto>(
      {url: `/translation/upsert-trans-list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertTransListDto
    },
      options);
    }
  


export const getTranslationControllerUpsertTransListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpsertTransList>>, TError,{data: UpsertTransListDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpsertTransList>>, TError,{data: UpsertTransListDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerUpsertTransList>>, {data: UpsertTransListDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerUpsertTransList(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerUpsertTransListMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerUpsertTransList>>>
    export type TranslationControllerUpsertTransListMutationBody = UpsertTransListDto
    export type TranslationControllerUpsertTransListMutationError = ErrorType<unknown>

    /**
 * @summary Upsert translation list (V1 upsertTransList)
 */
export const useTranslationControllerUpsertTransList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerUpsertTransList>>, TError,{data: UpsertTransListDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerUpsertTransList>>,
        TError,
        {data: UpsertTransListDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerUpsertTransListMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * V1 GraphQL의 useTranslationsLazyQuery와 동일한 기능. 기존 옵션 key를 검색하여 재사용할 때 사용합니다. key는 대소문자 무시 포함 검색(containsi), value는 번역된 라벨 포함 검색을 수행합니다. key와 value를 함께 사용하면 OR 조건으로 검색합니다.
 * @summary Search translations
 */
export const translationControllerSearch = (
    searchTranslationDto: SearchTranslationDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SearchTranslationResponseDto>(
      {url: `/translation/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchTranslationDto
    },
      options);
    }
  


export const getTranslationControllerSearchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerSearch>>, TError,{data: SearchTranslationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerSearch>>, TError,{data: SearchTranslationDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerSearch>>, {data: SearchTranslationDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerSearch(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerSearchMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerSearch>>>
    export type TranslationControllerSearchMutationBody = SearchTranslationDto
    export type TranslationControllerSearchMutationError = ErrorType<unknown>

    /**
 * @summary Search translations
 */
export const useTranslationControllerSearch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerSearch>>, TError,{data: SearchTranslationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerSearch>>,
        TError,
        {data: SearchTranslationDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Export translations for review
 */
export const translationControllerExportTranslationsForReview = (
    translationReviewExportDto: TranslationReviewExportDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TranslationReviewExportResponseDto>(
      {url: `/translation/review/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translationReviewExportDto
    },
      options);
    }
  


export const getTranslationControllerExportTranslationsForReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerExportTranslationsForReview>>, TError,{data: TranslationReviewExportDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerExportTranslationsForReview>>, TError,{data: TranslationReviewExportDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerExportTranslationsForReview>>, {data: TranslationReviewExportDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerExportTranslationsForReview(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerExportTranslationsForReviewMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerExportTranslationsForReview>>>
    export type TranslationControllerExportTranslationsForReviewMutationBody = TranslationReviewExportDto
    export type TranslationControllerExportTranslationsForReviewMutationError = ErrorType<unknown>

    /**
 * @summary Export translations for review
 */
export const useTranslationControllerExportTranslationsForReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerExportTranslationsForReview>>, TError,{data: TranslationReviewExportDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerExportTranslationsForReview>>,
        TError,
        {data: TranslationReviewExportDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerExportTranslationsForReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Import translations review sheet
 */
export const translationControllerImportTranslationsReview = (
    translationReviewImportDto: TranslationReviewImportDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TranslationReviewImportResponseDto>(
      {url: `/translation/review/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translationReviewImportDto
    },
      options);
    }
  


export const getTranslationControllerImportTranslationsReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerImportTranslationsReview>>, TError,{data: TranslationReviewImportDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerImportTranslationsReview>>, TError,{data: TranslationReviewImportDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerImportTranslationsReview>>, {data: TranslationReviewImportDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerImportTranslationsReview(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerImportTranslationsReviewMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerImportTranslationsReview>>>
    export type TranslationControllerImportTranslationsReviewMutationBody = TranslationReviewImportDto
    export type TranslationControllerImportTranslationsReviewMutationError = ErrorType<unknown>

    /**
 * @summary Import translations review sheet
 */
export const useTranslationControllerImportTranslationsReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerImportTranslationsReview>>, TError,{data: TranslationReviewImportDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerImportTranslationsReview>>,
        TError,
        {data: TranslationReviewImportDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerImportTranslationsReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Scan translation discrepancies
 */
export const translationControllerScanTranslationDiscrepancies = (
    translationReviewScanDto: TranslationReviewScanDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TranslationReviewScanResponseDto>(
      {url: `/translation/review/scan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translationReviewScanDto
    },
      options);
    }
  


export const getTranslationControllerScanTranslationDiscrepanciesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerScanTranslationDiscrepancies>>, TError,{data: TranslationReviewScanDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerScanTranslationDiscrepancies>>, TError,{data: TranslationReviewScanDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerScanTranslationDiscrepancies>>, {data: TranslationReviewScanDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerScanTranslationDiscrepancies(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerScanTranslationDiscrepanciesMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerScanTranslationDiscrepancies>>>
    export type TranslationControllerScanTranslationDiscrepanciesMutationBody = TranslationReviewScanDto
    export type TranslationControllerScanTranslationDiscrepanciesMutationError = ErrorType<unknown>

    /**
 * @summary Scan translation discrepancies
 */
export const useTranslationControllerScanTranslationDiscrepancies = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerScanTranslationDiscrepancies>>, TError,{data: TranslationReviewScanDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerScanTranslationDiscrepancies>>,
        TError,
        {data: TranslationReviewScanDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerScanTranslationDiscrepanciesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete translation entries (from review scan)
 */
export const translationControllerDeleteTranslationEntries = (
    translationReviewDeleteDto: TranslationReviewDeleteDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TranslationReviewDeleteResponseDto>(
      {url: `/translation/review/delete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translationReviewDeleteDto
    },
      options);
    }
  


export const getTranslationControllerDeleteTranslationEntriesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerDeleteTranslationEntries>>, TError,{data: TranslationReviewDeleteDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerDeleteTranslationEntries>>, TError,{data: TranslationReviewDeleteDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerDeleteTranslationEntries>>, {data: TranslationReviewDeleteDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerDeleteTranslationEntries(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerDeleteTranslationEntriesMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerDeleteTranslationEntries>>>
    export type TranslationControllerDeleteTranslationEntriesMutationBody = TranslationReviewDeleteDto
    export type TranslationControllerDeleteTranslationEntriesMutationError = ErrorType<unknown>

    /**
 * @summary Delete translation entries (from review scan)
 */
export const useTranslationControllerDeleteTranslationEntries = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerDeleteTranslationEntries>>, TError,{data: TranslationReviewDeleteDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerDeleteTranslationEntries>>,
        TError,
        {data: TranslationReviewDeleteDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerDeleteTranslationEntriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Translate entire survey (V1 transSurveyV2)
 */
export const translationControllerTranslateSurvey = (
    translateSurveyDto: TranslateSurveyDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TranslateSurveyResponseDto>(
      {url: `/translation/translate-survey`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translateSurveyDto
    },
      options);
    }
  


export const getTranslationControllerTranslateSurveyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateSurvey>>, TError,{data: TranslateSurveyDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateSurvey>>, TError,{data: TranslateSurveyDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerTranslateSurvey>>, {data: TranslateSurveyDto}> = (props) => {
          const {data} = props ?? {};

          return  translationControllerTranslateSurvey(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerTranslateSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerTranslateSurvey>>>
    export type TranslationControllerTranslateSurveyMutationBody = TranslateSurveyDto
    export type TranslationControllerTranslateSurveyMutationError = ErrorType<unknown>

    /**
 * @summary Translate entire survey (V1 transSurveyV2)
 */
export const useTranslationControllerTranslateSurvey = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateSurvey>>, TError,{data: TranslateSurveyDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerTranslateSurvey>>,
        TError,
        {data: TranslateSurveyDto},
        TContext
      > => {

      const mutationOptions = getTranslationControllerTranslateSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    